import React, { useState } from 'react'
import { useFormikContext } from 'formik'
import { useTranslation } from 'react-i18next'
import { Box, Text, Columns, Column, Button, TextLinkButton } from '@machobear/design-system'
import { FieldInput } from '@/components/ds-form'

const CouponField = ({
  isSubmitting,
  couponCode,
  onApply
}: {
  isSubmitting: boolean
  couponCode?: string | null | undefined
  onApply?: () => void
}) => {
  const { t } = useTranslation()
  const [showField, setShowField] = useState(!!couponCode)
  const { values }: { values: { couponCode: string } } = useFormikContext()
  const disableSubmit = !values?.couponCode || isSubmitting

  return !showField ? (
    <Text tone="link">
      <TextLinkButton onClick={() => setShowField(true)} weight="regular">
        {t('l.promotions.coupon.add.button.text', 'Add coupon')}
      </TextLinkButton>
    </Text>
  ) : (
    <Box>
      <Columns space="xsmall" alignY="top">
        <Column>
          <FieldInput
            name="couponCode"
            label={t('l.promotions.coupon.label.text', 'Enter coupon code')}
          />
        </Column>
        <Column width="content">
          {onApply ? (
            <Button
              type="button"
              variant="ghost"
              size="large"
              disabled={disableSubmit}
              onClick={onApply}
            >
              {t('l.promotions.coupon.apply.button.text', 'Apply')}
            </Button>
          ) : (
            <Button type="submit" variant="ghost" size="large" disabled={disableSubmit}>
              {t('l.promotions.coupon.apply.button.text', 'Apply')}
            </Button>
          )}
        </Column>
      </Columns>
    </Box>
  )
}

export default CouponField
